const util = {};

util.checkMoney = function(value) {
	value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
	value = value.replace(/^\./g, ""); //验证第一个字符是数字而不是.
	value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的.
	value = value.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3");
	value = value
		.replace(".", "$#$")
		.replace(/\./g, "")
		.replace("$#$", ".");
	return value;
};
util.toFixed = function(money) {
	if (money) {
		money = Number(money);
		return money.toFixed(2);
	}
	return "";
};
export { util };
